/* Our Story — Timeline scroll behaviour
   Self-contained, scoped per section instance so the section can be added to
   a page multiple times without conflicts.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 860px)';

  function initTimeline(root) {
    var track = root.querySelector('[data-ourstory-track]');
    var texts = Array.prototype.slice.call(root.querySelectorAll('[data-ourstory-text]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ourstory-dot]'));
    var media = root.querySelector('.ourstory-timeline__media');

    var slideCount = texts.length;
    if (!track || !media || slideCount === 0) return;

    var vhPerSlide = parseFloat(root.getAttribute('data-vh-per-slide')) || 100;
    var disableOnMobile = root.getAttribute('data-disable-on-mobile') === 'true';
    var mql = window.matchMedia(MOBILE_QUERY);

    var mode = null; // 'pinned' | 'stacked'
    var activeIndex = -1;
    var ticking = false;
    var listening = false;

    function setHeight() {
      root.style.height = mode === 'stacked' ? '' : (slideCount * vhPerSlide) + 'vh';
    }

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;
      texts.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
    }

    function update() {
      ticking = false;
      if (mode !== 'pinned') return;

      var rect = root.getBoundingClientRect();
      var viewportH = window.innerHeight;
      var scrollable = rect.height - viewportH;

      var progress = scrollable <= 0 ? 0 : (-rect.top) / scrollable;
      progress = Math.min(1, Math.max(0, progress));

      var mediaHeight = media.getBoundingClientRect().height;
      var maxTranslate = (slideCount - 1) * mediaHeight;
      track.style.transform = 'translateY(' + (-progress * maxTranslate) + 'px)';

      var index = Math.round(progress * (slideCount - 1));
      setActive(Math.min(slideCount - 1, Math.max(0, index)));
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    function startListening() {
      if (listening) return;
      listening = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    function stopListening() {
      if (!listening) return;
      listening = false;
      window.removeEventListener('scroll', onScroll);
    }

    function applyMode() {
      var shouldStack = disableOnMobile && mql.matches;
      var newMode = shouldStack ? 'stacked' : 'pinned';
      if (newMode === mode) return;
      mode = newMode;
      root.setAttribute('data-ourstory-mode', mode);

      if (mode === 'stacked') {
        track.style.transform = '';
        activeIndex = -1;
        stopListening();
      } else {
        activeIndex = -1;
      }
      setHeight();
      update();
    }

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyMode();
        setHeight();
        update();
      }, 100);
    }

    // Only listen to scroll while the section is anywhere near the viewport —
    // keeps the scroll handler from running on pages with many sections.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && mode === 'pinned') {
              startListening();
            } else {
              stopListening();
            }
          });
        },
        { rootMargin: '25% 0px 25% 0px' }
      );
      io.observe(root);
    } else {
      startListening();
    }

    window.addEventListener('resize', onResize);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onResize);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(onResize);
    }

    // Shopify theme editor support
    root.addEventListener('shopify:section:load', function () {
      applyMode();
      setHeight();
      update();
    });

    root.addEventListener('shopify:block:select', function (event) {
      var blockEl = event.target.closest('[data-ourstory-text]');
      if (!blockEl) return;
      var index = parseInt(blockEl.getAttribute('data-index'), 10);
      if (isNaN(index)) return;

      if (mode === 'pinned') {
        var rect = root.getBoundingClientRect();
        var scrollable = rect.height - window.innerHeight;
        var targetProgress = slideCount > 1 ? index / (slideCount - 1) : 0;
        var sectionTop = window.scrollY + rect.top;
        window.scrollTo({
          top: sectionTop + targetProgress * Math.max(scrollable, 0),
          behavior: 'smooth'
        });
      }
      setActive(index);
    });

    applyMode();
    setHeight();
    update();
  }

  function init() {
    document.querySelectorAll('[data-ourstory-timeline]').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
